import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ReactiveFormsModule} from '@angular/forms';
import {UIBaseModule} from "../../ui-base/ui-base.module";
import {UIFormModule} from "../../ui-form/ui-form.module";
import {LinkedEntitiesComponent} from "./components/linked-entities/linked-entities.component";
import {LinkedEntitiesService} from "@catmodels/linked-entities/services/linked-entities.service";
import {AddDeleteEntityComponent} from "@catmodels/linked-entities/components/add-entity/add-delete-entity.component";
import { LinkedEntityComponent } from './components/linked-entity/linked-entity.component';

const publicComponents = [
  LinkedEntitiesComponent,
  LinkedEntityComponent,
  AddDeleteEntityComponent,
];

const imports = [
  CommonModule,
  ReactiveFormsModule,
  UIFormModule,
  UIBaseModule,
  BrowserAnimationsModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [LinkedEntitiesService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class LinkedEntitiesModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/linked-entities/linked-entities.module.ts